import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsDirtyService {
  private isDirty$: BehaviorSubject<boolean>;
  constructor() {
    this.isDirty$ = new BehaviorSubject(false);
  }

  setIsDirty(dirty: boolean) {
    this.isDirty$.next(dirty);
  }

  getIsDirty() {
    return this.isDirty$.value;
  }
}
